import getWrappedUseQuery from "api/helpers/getWrappedUseQuery";
import apiClient from "api-client";

import KEYS from "../keys";

export const useGetBillingNotesQuery = getWrappedUseQuery(KEYS.GET_FORUM_BILLING_NOTES, apiClient.BillingNotes.get);
